import { useState, useEffect } from "react";

const useSessionStorage = (name) => {
  const [value, setValue] = useState("");

  useEffect(() => {
    const storageValue = sessionStorage.getItem(name);
    if (storageValue) {
      setValue(storageValue);
    }
  }, []);

  return value;
};

export { useSessionStorage };
